export const TKeySalesScript = {
  SALES_SCRIPT_NAV: "SALES_SCRIPT_NAV",
} as const;
